import initialState from './initialState';
import {
  FETCH_LAST_DATA_FFD_SLEEP_INIT,
  FETCH_LAST_DATA_FFD_SLEEP_SUCCESS,
  FETCH_LAST_DATA_FFD_SLEEP_FAILURE,
  FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_INIT,
  FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_SUCCESS,
  FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_FAILURE,
  FETCH_LAST_DATA_FFD_SLEEP_COUNT_INIT,
  FETCH_LAST_DATA_FFD_SLEEP_COUNT_SUCCESS,
  FETCH_LAST_DATA_FFD_SLEEP_COUNT_FAILURE,
  SET_FILTER_LAST_DATA_FFD_SLEEP,
  RESET_LAST_DATA_FFD_SLEEP
} from '../../actions/last_data_ffd_sleep/types';

export default function lastDataFfdSleep(state = initialState, action) {
  switch (action.type) {
    case FETCH_LAST_DATA_FFD_SLEEP_INIT:
      return {
        ...state,
        loading: true
      };
    case FETCH_LAST_DATA_FFD_SLEEP_SUCCESS:
      return {
        ...state,
        datos: action.payload.data,
        loading: false,
        status: action.payload.status
      };
    case FETCH_LAST_DATA_FFD_SLEEP_FAILURE:
      return {
        ...state,
        datos: [],
        loading: false
      };
    case FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_INIT:
      return {
        ...state,
        loadingTableSpiner: true
      };
    case FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_SUCCESS:
      return {
        ...state,
        datos: action.concat
          ? state.datos.concat(action.payload.data)
          : action.payload.data,
        loadingTableSpiner: false,
        status: action.payload.status
      };
    case FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_FAILURE:
      return {
        ...state,
        datos: [],
        loadingTableSpiner: false
      };
    case FETCH_LAST_DATA_FFD_SLEEP_COUNT_INIT:
      return {
        ...state
      };
    case FETCH_LAST_DATA_FFD_SLEEP_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload.data,
        statusCount: action.payload.status
      };
    case FETCH_LAST_DATA_FFD_SLEEP_COUNT_FAILURE:
      return {
        ...state,
        count: {}
      };
    case RESET_LAST_DATA_FFD_SLEEP:
      return {
        ...initialState,
        filters: state.filters
      };
    case SET_FILTER_LAST_DATA_FFD_SLEEP:
      return {
        ...state,
        filters: {
          periodReport: action.payload.periodReport,
          date: {
            fechaStartFinal: action.payload.date.fechaStartFinal,
            fechaEndFinal: action.payload.date.fechaEndFinal
          },
          tags: action.payload.tags,
          workingShiftGroup: action.payload.workingShiftGroup,
          driver: action.payload.driver
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/last_data_ffd_sleep/index.js